/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import {useSelector, useStore} from 'react-redux'
import {setCurrentApp} from '../store/appsSlice'
import {App, AppId} from '../model/apps'
import {AppRootState} from '../model/config'
import {useParameters} from '@enisco/mcc-react-lib'
import useRegisteredApps from './useRegisteredApps'
import {DefaultParameter} from '../model/defaultParameters'

const useCurrentApp = (): [App | undefined, (newApp: AppId, parameters?: Record<string, any>) => void] => {
  const [registeredApps] = useRegisteredApps(true)
  const currentApp = useSelector((state: AppRootState) => state.app.currentApp)
  const [, setParameters] = useParameters()
  const store = useStore<AppRootState>()

  const selectedApps = currentApp
    ? registeredApps.filter(
        (a) => a.module === currentApp.module && a.app === currentApp.app
      )
    : []
  const result = selectedApps.length > 0 ? selectedApps[0] : undefined

  return [
    result,
    (newApp: AppId, parameters?: Record<string, any>) => {
      if (newApp && Object.keys(newApp).length !== 0) {
        store.dispatch(setCurrentApp(newApp))
        const defaultParameter = store
          .getState()
          .app.defaultParameters.find(
            (para: DefaultParameter) =>
              para.app === newApp.app && para.module === newApp.module
          )
        const params = parameters ?? defaultParameter?.parameters ?? {}
        setParameters(params)
      }
    }
  ]
}

export default useCurrentApp
